import $ from 'jquery';

export default {
  fetch: function() {
    return $.ajax({
      url: '/stage-ajax/get-token/?v=2',
      dataType: 'text'
    });
  }
};
